/* eslint-disable no-useless-catch */
import { API } from "../api";
import {
  DEPARTMENTS_URL,
  DEPARTMENTS_WISE_ROLES
} from "../constants/url.constant";

export const GET_DEPARTMENTS = "GET_DEPARTMENTS";
export const ADD_HUB = "ADD_HUB";
export const DELETE_HUB = "DELETE_HUB";
export const UPDATE_HUB = "UPDATE_HUB";

export const getDepartments = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(DEPARTMENTS_URL, { params });
      if (Object.keys(params).length) {
        dispatch({
          type: GET_DEPARTMENTS,
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getDepartmentWiseRoles = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(DEPARTMENTS_WISE_ROLES, { params });
      if (Object.keys(params).length) {
        dispatch({
          payload: res
        });
      }
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const addDepartment = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(DEPARTMENTS_URL, data);
      dispatch({
        type: ADD_HUB,
        payload: data
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateDepartment = (code, body) => {
  return async (dispatch) => {
    try {
      await API.put(`${DEPARTMENTS_URL}/${code}`, body);
      dispatch({ type: UPDATE_HUB, payload: { code, ...body } });
    } catch (error) {
      throw error;
    }
  };
};

export const removeDepartment = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${DEPARTMENTS_URL}/${id}`);
      dispatch({
        type: DELETE_HUB,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export default function reducer(
  state = { departmentTableRows: [], totalRows: 0 },
  { type, payload }
) {
  switch (type) {
    case GET_DEPARTMENTS:
      return {
        ...state,
        departmentTableColumns: payload.columns,
        departmentTableRows: payload.rows,
        totalRows: payload.count
      };
    case ADD_HUB:
      return {
        ...state,
        totalRows: state.totalRows + 1,
        departmentTableRows: [...state.departmentTableRows, { ...payload }]
      };
    case DELETE_HUB:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        departmentTableRows: state.departmentTableRows.filter(
          (department) => department.code !== payload
        )
      };
    case UPDATE_HUB:
      return {
        ...state,
        departmentTableRows: state.departmentTableRows.map((department) =>
          department.code === payload.code ? { ...payload } : department
        )
      };
    default:
      return state;
  }
}
